import React, { useCallback } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import { Button, Modal } from "@mapmycustomers/ui";

import processingImage from "@app/assets/map/leadFinderProgress.svg";
import { cancelLeadFinderSearch } from "@app/scene/map/store/leadFinder/actions";
import { getLeadFinderProcessing } from "@app/scene/map/store/leadFinder/selectors";
import { RootState } from "@app/store/rootReducer";
import { TOPMOST_MODAL_ZINDEX } from "@app/util/consts";

import styles from "./ProcessingModal.module.scss";

interface Props {
  cancelLeadFinderSearch: typeof cancelLeadFinderSearch;
  visible: boolean;
}

const messages = defineMessages({
  cancelBtn: {
    id: "map.tool.leadFinder.popover.processing.cancelBtn",
    defaultMessage: "Cancel",
    description: "Cancel button title",
  },
  text: {
    id: "map.tool.leadFinder.popover.processing.text",
    defaultMessage: "Finding leads that meet your search",
    description: "Finding leads that meet your search",
  },
});

const ProcessingModal: React.FC<Props> = ({ cancelLeadFinderSearch, visible }) => {
  const intl = useIntl();

  const handleCancel = useCallback(() => {
    cancelLeadFinderSearch();
  }, [cancelLeadFinderSearch]);

  return (
    <Modal
      centered
      closable={false}
      destroyOnClose
      footer={null}
      maskClosable={false}
      onCancel={handleCancel}
      visible={visible}
      width={475}
      zIndex={TOPMOST_MODAL_ZINDEX}
    >
      <div className={styles.container}>
        <div className={styles.animation}>
          <img alt="Searching" src={processingImage} />
        </div>

        <div className={styles.text}>{intl.formatMessage(messages.text)}</div>

        <Button onClick={handleCancel} type="link">
          {intl.formatMessage(messages.cancelBtn)}
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  visible: getLeadFinderProcessing(state),
});

const mapDispatchToProps = {
  cancelLeadFinderSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessingModal);
